import { render } from "./ColumnList.vue?vue&type=template&id=b68ab624"
import script from "./ColumnList.vue?vue&type=script&lang=js"
export * from "./ColumnList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__